module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mu-overlay-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "mu-overlay",
    style: (_vm.overlayStyle),
    on: {
      "click": _vm.handleClick,
      "touchmove": _vm.prevent
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf666cf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/internal/popup/overlay.vue
// module id = 888
// module chunks = 34